import React, { useState } from 'react';
import UpdateMobileNumberModel from "./ChangeMobileNumberModal/UpdateMobileNumberModel";
import { reactGaEvent } from "examsbook-react-sdk/actions/Common";
// import EditUserProfile from "./EditUserProfile/EditUserProfile";
import OtpVerificationModel from "./OtpModal/OtpVerificationModel";
import { requestNewOtp } from "examsbook-react-sdk/services/userService";
import { useSelector } from "react-redux";
import UserProfileView from "./UserProfileView";

/**
 * Profile information block.
 * @param props
 * @returns {*}
 * @constructor
 */
function UserProfile(props) {
    const user = useSelector(state => state.user);
    const [ isMobilePopupOpen, setIsMobilePopupOpen ] = useState(false);
    const [ showUpdateUserModel, setShowUpdateUserModel ] = useState(false);
    const [ isOtpModelOpen, setOtpModelOpen ] = useState(false);

    function requestOtp() {
        reactGaEvent("Phone number verification", "OTP requested");
        requestNewOtp().then((response) => {
        });
        setOtpModelOpen(true);
    }

    function toggleMobileNumberModel() {
        setIsMobilePopupOpen(!isMobilePopupOpen);
    }

    /**
     * Toggle profile update model.
     */
    function toggleProfileUpdateModel() {
        setShowUpdateUserModel(!showUpdateUserModel);
    }

    function closeOtpModel() {
        setOtpModelOpen(false);
    }

    return (
        <div className="profile-information">
            <UpdateMobileNumberModel toggleMobileNumberModel={toggleMobileNumberModel}
                                     isEditMobileNumberModalOpen={isMobilePopupOpen}/>
            <OtpVerificationModel
                isOtpModelOpen={isOtpModelOpen}
                mobileNumber={user.mobileNumber}
                closeModel={closeOtpModel}/>
            {/* <EditUserProfile
                showUpdateUserModel={showUpdateUserModel}
                onProfileUpdateModelClose={toggleProfileUpdateModel}/> */}
            <UserProfileView
                requestOtp={requestOtp}
                toggleMobileNumberModel={toggleMobileNumberModel}
                toggleProfileUpdateModel={toggleProfileUpdateModel}
                user={user}/>
        </div>
    );
}

export default UserProfile;
